import { render, staticRenderFns } from "./WithdrawalHistory.vue?vue&type=template&id=60061a2d&scoped=true&"
import script from "./WithdrawalHistory.vue?vue&type=script&lang=js&"
export * from "./WithdrawalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60061a2d",
  null
  
)

export default component.exports